import { markets } from "@features/market/config/market-config";
import type { CountryCodeEnum } from "@features/market/config/i18n-config";
import { z } from "zod";

const marketCodeSchema = {} as Record<CountryCodeEnum, z.ZodNumber>;

Object.values(markets).forEach((market) => {
  marketCodeSchema[market.countryCode] = z.number();
});

export const minimumOrderValueSchema = z.object(marketCodeSchema);

export type MinimumOrderValue = z.infer<typeof minimumOrderValueSchema>;
